<div fxLayout="column">
    <h2 fxFlex="0 0 auto" mat-dialog-title>Projection Update</h2>
    <mat-dialog-content fxFlex="auto">
        <form  class="correction-form" [formGroup]="correctionFormGroup" novalidate>
            <div fxLayout="column" fxLayoutGap="20px">
                <div fxFlex="auto" fxLayout="row wrap">
                    <mat-form-field fxFlex="1 1 10%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'currency'" fxFlex="1 1 auto" placeholder="Currency" floatPlaceholder="always" formControlName="currency" name="currency" (selectionChange)="projectionUpdateKeyTypesSelected($event)">
                            <mat-option *ngFor="let currency of currencies" [value]="currency">
                                {{ currency }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 10%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'direction'" fxFlex="1 1 auto" placeholder="Direction" floatPlaceholder="always" formControlName="direction"  name="direction" (selectionChange)="projectionUpdateKeyTypesSelected($event)">
                            <mat-option *ngFor="let direction of directions" [value]="direction">
                                {{ direction }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'client-group'" fxFlex="1 1 auto" placeholder="Client Group" floatPlaceholder="always" formControlName="clientGroup" name="clientGroup" (selectionChange)="projectionUpdateKeyTypesSelected($event)">
                            <mat-option *ngFor="let clientGroup of clientGroups" [value]="clientGroup">
                                {{ clientGroup }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 30%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'product-type'" fxFlex="1 1 auto" placeholder="Product Type" floatPlaceholder="always" formControlName="productType" name="productType" (selectionChange)="projectionUpdateKeyTypesSelected($event)">
                            <mat-option *ngFor="let productType of productTypes" [value]="productType">
                                {{ productType }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'desk'" fxFlex="1 1 auto" placeholder="Desk" floatPlaceholder="always"  formControlName="desk" name="desk" (selectionChange)="projectionUpdateKeyTypesSelected($event)">
                            <mat-option *ngFor="let desk of desks" [value]="desk">
                                {{ desk }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="auto" fxLayout="row wrap" >
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Start of Day Projection" type="number" disabled  formControlName="startingAmount">
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Current Projection" type="number" disabled   formControlName="currentAmount">
                        <mat-hint *ngIf="data.projectionChange !== 0">Change: {{ data.projectionChange }}
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Filled Amount" type="number" disabled formControlName="filledAmount">
                        <mat-hint *ngIf="data.projectionCompletionPercentage">Completion: {{ data.projectionCompletionPercentage | number : '1.0-0'}}%
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto">
                        <span matPrefix>{{data.correction.direction === 'PAY' ? '- ' : ''}}</span>
                        <input matInput required placeholder="New Projection" type="number" name="newAmount" formControlName="newAmount">
                    </mat-form-field>
                    <!-- <mat-form-field class="text-align-end" fxFlex="0 1 auto">
                      <input matInput class="text-align-end" placeholder="Original Percentage" disabled [value]="data.correction.assumptionOriginalPercentage">
                      <mat-hint align="end">Assumption Amount: {{(data.correction.assumptionOriginalAmount * data.correction.assumptionOriginalPercentage
                          / 100) | number : '1.1-1'}}
                      </mat-hint>
                  </mat-form-field> -->
                    <!-- <mat-form-field class="text-align-end" fxFlex="0 1 auto">
                      <input matInput type="number" min="0" max="100" class="text-align-end" maxlength="3" required placeholder="New Percentage"
                          [(ngModel)]="data.correction.assumptionNewPercentage" name="assumptionNewPercentage">
                      <mat-hint align="end">{{ (data.correction.assumptionOriginalAmount * data.correction.assumptionNewPercentage / 100) | number
                          : '1.1-1'}}
                      </mat-hint>
                  </mat-form-field> -->
                </div>
                <div fxLayout="row">
                    <mat-form-field fxFlex="auto">
                        <input matInput placeholder="Reason" required formControlName="changeReason" name="changeReason">
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <div fxFlexFill>
        <span> </span>
    </div>

    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" [disabled]="!correctionFormGroup.valid" (click)="submit()" [mat-dialog-close]="submitResult">Submit</button>
    </mat-dialog-actions>

</div>